<template lang="pug">
  .white.rc-login-history(style="min-height: calc(100% - 48px)" v-rc-loader="!ready")
    v-layout.login-history-wrapper(v-if="logins.length")
      rc-table.elevation-2.mb-4.mt-3(
        @recall="getLogins"
        :totalItems="totalLogins"
        :items="logins"
        :headers="headers"
        :loading="loginsLoading"
        :displaySortable="false"
        :deleteAction="false"
        :clickToVisit="false"
      )
    v-layout.justify-center.pt-5.px-5.font-italic.text-xs-center.subheading.grey--text.text--darken-2(v-else)
      |Cet accès n'est c'est connecté à aucune application.
</template>

<script>
import RcTable from '@/components/RcTable/RcTable.vue';
import axios from 'axios';

export default {
  components: {
    RcTable,
  },
  data() {
    return {
      logins: [],
      totalLogins: 0,
      loginsLoading: true,
      ready: false,
      headers: [
        {
          label: 'ID',
          type: 'id',
          sortable: false,
          column: 'id',
          width: '0px',
        },
        {
          label: 'Application',
          sortable: false,
          column: 'application',
          width: '30%',
          type: 'capitalize',
          filters: {
            type: 'select_multiple',
            operands: ['in'],
            values: [],
            label: 'name',
            key: 'id',
            field: 'application',
          }
        },
        {
          label: 'Clé de site',
          sortable: false,
          column: 'site_key',
          width: '30%',
        },
        {
          label: 'Date',
          type: 'dateTime',
          sortable: false,
          column: 'login_date',
          width: '40%',
        },
      ],
    };
  },
  mounted() {
    this.getApplications();
    this.getLogins();
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    async getApplications() {
      const contactId = this.$route.params.contactId;
      const appResponse = await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).get(`/v2/erp/contact/${contactId}/logins/history/applications`);
      const headers = this.headers;
      const appHeader = this.headers.find(x => x.column === 'application');
      appHeader.filters.values = appResponse.data.map(it => { return { id: it, name: this.capitalize(it) }; });
      this.headers = headers;
    },

    async getLogins({start = 0, size = 100, filters = []} = {}) {
      const contactId = this.$route.params.contactId;
      this.loginsLoading = true;
      axios.create({ headers: { 'Cache-Control' : 'no-cache' } })
      .post(`/v2/erp/contact/${contactId}/logins/history`, {
        start,
        size,
        filters,
      }).then((loginsResponse) => {
        this.ready = true;
        this.logins = loginsResponse.data.values;
        this.totalLogins = loginsResponse.data.count;
        this.loginsLoading = false;
      });
    },
  },
}
</script>

<style lang="scss">
  .rc-login-history {
    .login-history-wrapper {
      max-height: 100%;
      .products-table {
        border-top: 1px solid #fafafa;
      }
    }
    .selected-product {
      background-color: var(--primary);
      color: white;
      transition: none;
    }
    .product-tile {
      transition: none;
      &:not(:last-of-type) {
        border-bottom: 1px solid lightgrey;
      }
    }
    .table-header {
      font-size: 16px!important;
    }
  }
</style>


